/**
 *  Wyświetla listę ćwiczeń/gier w danym odcinku
 */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import List from '@material-ui/core/List';
import PartListItem from './PartListItem';
import { getCourseSection } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '&>div': {
      paddingLeft: 23,
    }
  },
}));

let timeout = 0;

function PartList(props) {
  const { id, game, title, getCourseSection } = props;
  const classes = useStyles();
  const section = props.courseSections.find(section => section.id === id);

  useEffect(() => {
    if (section.parts.length === 0) getCourseSection(id, title, game);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (section.parts.length === 0) return;
    scrollIntoView();
    // eslint-disable-next-line
  }, [section.parts]);

  const scrollIntoView = () => {
    clearTimeout(timeout);
    setTimeout(() => {
      if (props?.listRef?.current) props.listRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }, 100);
  }


  if (!section.parts || section.parts.length === 0) return '';
  return (
    <List component="nav" className={classes.root}>
      {section.parts.map(part => {
        return <PartListItem key={part.type + part.id} part={part} sectionSlug={section.slug} />
      })}
    </List>
  );
}

const mapStateToProps = (state) => {
  return {
    courseSections: state.courseSections,
    userState: state.userState,
  };
}

export default connect(mapStateToProps, { getCourseSection })(PartList);